<template>
  <div>
    <h2>Report By Date Range</h2>
    <div class="row">
      <div class="col-md-3">
        <label for="">Date From</label>
        <input type="text" class="form-control" v-model="params.date_from" />
      </div>
      <div class="col-md-3">
        <label for="">Date To</label>
        <input type="text" class="form-control" v-model="params.date_to" />
      </div>
      <div class="col-md-3">
        <label for="">Status</label>
        <select class="form-select" v-model="params.status">
          <option
            :value="status.value"
            v-for="(status, index) in token_status"
            :key="index"
          >
            {{ status.label }}
          </option>
        </select>
      </div>
      <div class="col-md-3">
        <label for="">Service</label>
        <select class="form-select" v-model="params.service_id">
          <option
            :value="service.id"
            v-for="(service, index) in services"
            :key="index"
          >
            {{ service.title }}
          </option>
        </select>
      </div>
      <div class="col-md-12 mt-3">
        <a class="btn btn-primary" v-on:click="getData()">Filter</a>
      </div>
    </div>
    <div class="list-table">
      <table class="table">
        <thead>
          <tr>
            <th>Date</th>
            <th>Mobile Number</th>
            <th>Service</th>
            <th>Token Number</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="d in data" :key="d.id">
            <td>{{ toDMY(d.date) }}</td>
            <td>{{ d.contact_number }}</td>
            <td>{{ d.service.title }}</td>
            <td>{{ d.token_number }}</td>
            <td v-html="tokenStatusHtml(d.status)"></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
export default {
  name: "ReportByDate",
  data() {
    return {
      data: [],
      params: {
        date_from: null,
        date_to: null,
        status: null,
        service_id: null,
      },
      token_status: [],
      services: [],
    };
  },
  methods: {
    getData() {
      this.$http
        .get("token/by-criteria", { params: this.params })
        .then((res) => {
          if (res.data.status == 1) {
            this.data = res.data.data;
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();
    },
    getCriteriaValues() {
      this.$http
        .get("token/by-criteria/filter-values")
        .then((res) => {
          console.log(res.data.data.services);
          if (res.data.status == 1) {
            this.token_status = res.data.data.token_status;
            this.services = res.data.data.services;
          } else {
            this.$notify({
              group: "notifications",
              title: res.data.message,
              type: "error",
              text: res.data.errors[0],
            });
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();
    },
  },
  mounted() {
    let d = new Date();
    this.params.date_to = this.toDMY(d);
    d.setDate(d.getDate() - 7);
    this.params.date_from = this.toDMY(d);
    this.getCriteriaValues();
    this.getData();
  },
};
</script>
